export default "__VITE_ASSET__Bdh1AfG6__"